import { theme } from '@superhi/design'
import { ResponsiveBreakpoint } from '@superhi/design/dist/cjs/theme/media'
import styled from 'styled-components'

export type WrapperProps = {
  $width?: Record<ResponsiveBreakpoint, number>
  $height?: Record<ResponsiveBreakpoint, number>
  $color?: keyof typeof theme.colors
}

export const Wrapper = styled.svg.attrs<WrapperProps>({
  width: '500',
  height: '117',
  viewBox: '0 0 500 117',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
})<WrapperProps>`
  display: block;
  max-width: 100%;
  color: ${({ $color }) => ($color ? theme.colors[$color] : 'currentColor')};
  width: ${({ $width }) => ($width?.small ? $width.small + 'px' : 'auto')};
  height: ${({ $height }) => ($height?.small ? $height.small + 'px' : 'auto')};

  @media ${theme.breakpoints.medium} {
    width: ${({ $width }) => ($width?.medium ? $width.medium + 'px' : 'auto')};
    height: ${({ $height }) => ($height?.medium ? $height.medium + 'px' : 'auto')};
  }

  @media ${theme.breakpoints.large} {
    width: ${({ $width }) => ($width?.large ? $width.large + 'px' : 'auto')};
    height: ${({ $height }) => ($height?.large ? $height.large + 'px' : 'auto')};
  }
`
